import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'cm-audio-output-test',
    templateUrl: './audio-output-test.component.html',
    styleUrls: ['./audio-output-test.component.scss'],
    standalone: false
})
export class AudioOutputTestComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
